// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"xPnkst","link":"GaanYo","disabled":"PiudET","navItem":"SlZKNv"};